import { Phone, Mail, Clock, Info } from "lucide-react";
import { waLink, telHref } from "../../lib/site";
import { WhatsAppIcon } from "./WhatsAppFloat";
import { SectionHeading } from "./SectionHeading";

const Row = ({ icon: Icon, label, children, testid }) => (
  <div data-testid={testid} className="flex gap-5 py-6 border-b border-zinc-800/80">
    <Icon className="text-[#D4AF37] shrink-0 mt-1" size={18} strokeWidth={1.6} />
    <div>
      <p className="font-caps text-[10px] text-zinc-500">{label}</p>
      <div className="mt-1.5 text-zinc-100 whitespace-pre-line">{children}</div>
    </div>
  </div>
);

export const Contact = ({ content }) => {
  const wa = waLink(content, content.whatsapp_message);
  return (
    <section id="contato" data-testid="contact-section" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-5 lg:px-10 grid lg:grid-cols-2 gap-14">
        <div>
          <SectionHeading eyebrow="Reservas" title={content.contact_title} intro={content.contact_intro} />
          <div className="mt-10 flex flex-col sm:flex-row gap-3">
            <a href={telHref(content.phone)} data-testid="contact-phone-btn" className="btn-outline-gold"><Phone size={16} /> {content.phone}</a>
            {wa && <a href={wa} target="_blank" rel="noopener noreferrer" data-testid="contact-whatsapp-btn" className="btn-gold"><WhatsAppIcon className="w-4 h-4" /> {content.btn_whatsapp}</a>}
          </div>
        </div>
        <div className="border-t border-zinc-800/80">
          <Row icon={Phone} label={content.phone_label} testid="contact-phone"><a href={telHref(content.phone)} className="hover:text-[#E6C687]">{content.phone}</a></Row>
          {content.email && <Row icon={Mail} label="E-mail" testid="contact-email"><a href={`mailto:${content.email}`} className="hover:text-[#E6C687] break-all">{content.email}</a></Row>}
          {content.contact_hours && <Row icon={Clock} label="Horários" testid="contact-hours">{content.contact_hours}</Row>}
          {content.contact_extra && <Row icon={Info} label="Informações" testid="contact-extra">{content.contact_extra}</Row>}
        </div>
      </div>
    </section>
  );
};
